export const DESKTOP_MOCKUP_WIDTH = 1175;
export const MOBILE_MOCKUP_WIDTH = 670;
